var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('process-tabs',{ref:"processTabsRef",attrs:{"processType":"mase","tableData":_vm.tableData,"module":_vm.module,"daytime":_vm.daytime},on:{"getTableData":_vm.getTableData}})}
var staticRenderFns = []

export { render, staticRenderFns }